export const formatFinancialSummaryStudent = (student: any) => {
  const plans = Array.isArray(student?.plans) ? student.plans : [];

  return {
    ...student,
    utilisateur: `${student?.firstname ?? ""} ${student?.lastname ?? ""}`.trim(),
    id_class: student?.classId || "",
    classe: student?.classLabel
      ? `${student?.levelAbbreviation || ""} - ${student.classLabel}`
      : "",
    Registrations: [
      {
        id: student?.registrationId,
        blocked_Note: Boolean(student?.blocked_Note),
        Class: {
          id: student?.classId,
          label: student?.classLabel,
          abbreviation: student?.classAbbreviation,
          Level: { abbreviation: student?.levelAbbreviation },
        },
      },
    ],
    plan: plans.map((plan: any) => ({
      id: plan.assignmentId,
      PaymentPlan: {
        id: plan.planId,
        label: plan.label,
        due_date: plan.dueDate,
        amount: Number(plan.amount || 0),
      },
    })),
    myDiscounts: [
      {
        repartitions: plans
          .filter((plan: any) => Number(plan.discountAmount || 0) > 0)
          .map((plan: any) => ({
            student_repartition_id: plan.assignmentId,
            repartition_amount: Number(plan.discountAmount || 0),
          })),
      },
    ],
    // Une répartition agrégée par plan suffit aux calculs de la liste.
    // L'historique réel est chargé seulement à l'ouverture du modal Finance.
    payments: [
      {
        summaryOnly: true,
        repartitions: plans
          .filter((plan: any) => Number(plan.paidAmount || 0) > 0)
          .map((plan: any) => ({
            amount: Number(plan.paidAmount || 0),
            payment_plan: { id: plan.assignmentId },
          })),
      },
    ],
  };
};
